// extracted by mini-css-extract-plugin
export default {"growth_content":"Growth_growth_content__O-jIg","growth_nav":"Growth_growth_nav__i3mDk","growth_page":"Growth_growth_page__hJnqh"};